import * as React from 'react';
import { PriceListCategory, PriceListSubCategory } from '../pricelist/PriceListInterfaces';
import { isHtml } from './TextUtil';

const markedObjectKeysRegexPattern = '"([a-z]+)?<mark class=\'text-bold\'>[a-z]+<\\/mark>([a-z]+)?":(null|[^a-z])';

export const renderValueAsHtml = (value: string) => {
  return isHtml(value) ? <span dangerouslySetInnerHTML={{ __html: value }} /> : value;
};

export const removeMarkUpHtmlFromString = (stringWithHtml: string) => {
  return stringWithHtml.replace("<mark class='text-bold'>", '').replace('</mark>', '');
};

const removeMarkupFromPriceByType = (markupString: string, priceType: string) => {
  // eslint-disable-next-line no-useless-escape
  const priceWithoutVatRegex = new RegExp(`"${priceType}":"[a-z0-9.<\\s=\'->]+`, 'gi');
  return markupString.replace(priceWithoutVatRegex, function (match) {
    return removeMarkUpHtmlFromString(match);
  });
};

const getRegexWithEscapedSpecialCharacters = (searchTerm: string) => {
  const escapedSearchTerm = searchTerm.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  return new RegExp(escapedSearchTerm, 'gi');
};

export const getPriceListTabItemId = (categoryIndex: number) => `pricelist-tabsitem-${categoryIndex}`;

export const filterContentBySearchTerm = (
  searchTerm: string,
  categories: PriceListCategory[],
  isPrivateCustomer: boolean,
  isPricesWithVatHidden: boolean,
): PriceListCategory[] => {
  const searchRegex = getRegexWithEscapedSpecialCharacters(searchTerm);
  const filteredCategories: PriceListCategory[] = [];

  categories.forEach((category) => {
    const categoryCopy = Object.assign({}, category);
    let searchTermOccurrencesInCategory = 0;
    const filteredSubCategories: PriceListSubCategory[] = [];

    categoryCopy.subCategories.forEach((subCategory) => {
      let subCategoryAsString = JSON.stringify(subCategory);
      subCategoryAsString = subCategoryAsString.replace(searchRegex, function (match) {
        return `<mark class='text-bold'>${match}</mark>`;
      });
      subCategoryAsString = subCategoryAsString.replace(new RegExp(markedObjectKeysRegexPattern, 'gi'), function (match) {
        return removeMarkUpHtmlFromString(match);
      });

      if (isPrivateCustomer) {
        subCategoryAsString = removeMarkupFromPriceByType(subCategoryAsString, 'price');
      }

      if (isPricesWithVatHidden) {
        subCategoryAsString = removeMarkupFromPriceByType(subCategoryAsString, 'priceWithVat');
      }

      const searchTermOccurrences = (subCategoryAsString.match(new RegExp('<mark class=', 'g')) || []).length;
      searchTermOccurrencesInCategory = searchTermOccurrencesInCategory + searchTermOccurrences;
      const editedSubCategory: PriceListSubCategory = JSON.parse(subCategoryAsString);
      editedSubCategory.containsSearchTerm = searchTermOccurrences > 0;
      filteredSubCategories.push(editedSubCategory);
    });

    categoryCopy.searchTermHits = searchTermOccurrencesInCategory;
    categoryCopy.containsSearchTerm = searchTermOccurrencesInCategory > 0;
    categoryCopy.subCategories = filteredSubCategories;
    filteredCategories.push(categoryCopy);
  });
  return filteredCategories;
};

export const getIndexForCategoryWithMostSearchTermHits = (categories: PriceListCategory[]): number => {
  let mostRelevantCategoryIndex = undefined;
  let highestSearchTermHits = 0;
  categories.forEach((category, categoryIndex) => {
    if (category.containsSearchTerm && category.searchTermHits > highestSearchTermHits) {
      highestSearchTermHits = category.searchTermHits;
      mostRelevantCategoryIndex = categoryIndex;
    }
  });
  return mostRelevantCategoryIndex;
};
